import React from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { Box, Container, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ClosingCTA = () => {
  const { t } = useTranslation();
  const { lng } = useParams();

  return (
    <Box
      sx={{
        background: 'linear-gradient(180deg, #1A1A1A 0%, #1E3A5F 100%)',
        pt: { xs: 6, md: 8 },
        pb: { xs: 6, md: 8 },
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Subtle radial glow */}
      <Box
        sx={{
          position: 'absolute',
          top: '-30%',
          right: '-10%',
          width: '50%',
          height: '100%',
          background: 'radial-gradient(circle, rgba(37,99,235,0.15), transparent 60%)',
          pointerEvents: 'none',
        }}
      />

      <Container maxWidth="md" sx={{ position: 'relative', textAlign: 'center' }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 600,
            color: '#FFFFFF',
            mb: 2.5,
            fontSize: { xs: '26px', md: '36px' },
            lineHeight: 1.15,
            letterSpacing: '-0.02em',
          }}
        >
          {t('home.closingCta.title')}
        </Typography>

        <Typography
          sx={{
            color: 'rgba(255,255,255,0.6)',
            fontSize: { xs: '15px', md: '17px' },
            lineHeight: 1.6,
            maxWidth: '45ch',
            mx: 'auto',
            mb: 4,
          }}
        >
          {t('home.closingCta.subtitle')}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 2,
            justifyContent: 'center',
          }}
        >
          <Button
            component={RouterLink}
            to={`/${lng}/comparadores`}
            variant="contained"
            sx={{
              height: '48px',
              px: 5,
              fontSize: '15px',
              fontWeight: 700,
              borderRadius: '10px',
              backgroundColor: '#FFFFFF',
              color: '#1A1A1A',
              textTransform: 'none',
              boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
              '&:hover': {
                backgroundColor: '#F7F9FC',
                boxShadow: '0 6px 24px rgba(0,0,0,0.25)',
              },
            }}
          >
            {t('home.closingCta.compareButton')}
          </Button>
          <Button
            component={RouterLink}
            to={`/${lng}/empieza-aqui`}
            variant="outlined"
            sx={{
              height: '48px',
              px: 5,
              fontSize: '15px',
              fontWeight: 500,
              borderRadius: '10px',
              borderWidth: '2px',
              borderColor: 'rgba(255,255,255,0.4)',
              color: '#FFFFFF',
              textTransform: 'none',
              '&:hover': {
                borderWidth: '2px',
                borderColor: 'rgba(255,255,255,0.6)',
                backgroundColor: 'rgba(255,255,255,0.05)',
              },
            }}
          >
            {t('home.closingCta.guideButton')}
          </Button>
        </Box>

        {/* Social proof */}
        <Typography
          sx={{
            color: 'rgba(255,255,255,0.5)',
            fontSize: '14px',
            mt: 4,
            textAlign: 'center',
          }}
        >
          {t('home.closingCta.socialProof')}
        </Typography>
      </Container>
    </Box>
  );
};

export default ClosingCTA;
